export default __webpack_public_path__ + "static/media/star.033b093c.png";